/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefApiKeyData } from '../../models/api-def-api-key-data';

export interface OrganizationsCreateApiKey$Params {
  organizationId: string;
      body: {

/**
 * Name for the API key
 */
'name'?: string;

/**
 * List of project IDs to apply to (optional)
 */
'projects'?: Array<string>;

/**
 * Expiration date (optional)
 */
'expiresAt'?: string | null;
}
}

export function organizationsCreateApiKey(http: HttpClient, rootUrl: string, params: OrganizationsCreateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'apiKey'?: ApiDefApiKeyData;

/**
 * The API key value (only returned on creation)
 */
'plainKey'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateApiKey.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'apiKey'?: ApiDefApiKeyData;
      
      /**
       * The API key value (only returned on creation)
       */
      'plainKey'?: string;
      }>;
    })
  );
}

organizationsCreateApiKey.PATH = '/organizations/{organizationId}/api-keys';
